const mitraPaymentDomainBaseUrl = process.env.MITRA_PAYMENT_DOMAIN_BASE_URL;

export default mitraPaymentDomainBaseUrl;
